import { useMediaQuery } from "react-responsive";

import ButtonRectangle from "../components/ButtonRectangle";
import usePokemons from "../utils/usePokemons";
import { FilterByElements } from "../components/FilterByElements";
import { PokemonCard } from "../components/PokemonCard";
import PokemonDetailsCard from "../components/PokemonDetailsCard";
import SearchInput from "../components/SearchInput";
import SimpleFooter from "../components/SimpleFooter";
import { useRef, useState } from "react";
import { useEffect } from "react";
import FichaTecnicaTableta from "../components/FichaTecnicaTableta";
import DetailsMesures from "../components/DetailsMesures";
import Ranking from "../components/Ranking";
import Stats from "../components/Stats";

// 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
function Pokedex() {
  // const pokemons = usePokemons();
  /* ALL STATES */
  const [typeEl, setTypeEl] = useState("");
  const [pokemonName, setPokemonName] = useState("");
  const [mainDetailsURL, setMainDetailsURL] = useState([]);

  const [showMainPokemonCol, setShowMainPokemonCol] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [idMain, setIdMain] = useState();

  const firstEvol =
    "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/172.png";
  const secondEvol =
    "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/25.png";
  const thirdEvolution =
    "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/26.png";

  const { pokemonsUtils: allPokemons, isLoading } = usePokemons();
  const [visibleLoading, setVisibleLoading] = useState(40);
  const loadMoreRef = useRef();
  // const allPokemons = usePokemons() filters;
  const filteredPokemons = pokemonName
    ? allPokemons.filter((pokemon) =>
        pokemon.name.includes(pokemonName.toLocaleLowerCase())
      )
    : allPokemons;
  useEffect(() => {
    if (!filteredPokemons || filteredPokemons.length === 0) return;

    const observerLoading = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisibleLoading((prev) => {
            const nextCount = prev + 20;
            return nextCount <= filteredPokemons.length
              ? nextCount
              : filteredPokemons.length;
          });
        }
      },
      { rootMargin: "100px" }
    );
    if (loadMoreRef.current) {
      observerLoading.observe(loadMoreRef.current);
    }
    return () => {
      if (loadMoreRef.current) observerLoading.unobserve(loadMoreRef.current);
    };
  }, [filteredPokemons]);
  const visiblePokemons = filteredPokemons?.slice(0, visibleLoading);

  const isDesktop = useMediaQuery({ minWidth: 1024 });
  useEffect(() => {
    const checkSizeScreen = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkSizeScreen();
    window.addEventListener("resize", checkSizeScreen);
    return () => {
      window.removeEventListener("resize", checkSizeScreen);
    };
  });
  const toggleColumn = () => {
    setShowMainPokemonCol((prevState) => !prevState);
    if (isMobile) {
      setShowMainPokemonCol(!showMainPokemonCol);
      console.log("esta opcion solo aparece en mobiles");
    }
  };
  const colorOutcome = "red";

  const cleanMainURL = () => {
    setMainDetailsURL([]);
  };
  const setFiltroElement = (elemento) => {
    setTypeEl(elemento);
  };
  //limpia el filtro de busqueda
  const onCleanFilter = () => {
    setTypeEl("");
    setPokemonName("");
  };

  const handleOnChangeSearch = (e) => {
    setPokemonName(e.target.value.toLowerCase());
  };

  return (
    <div className="main-pok">
      {/* {filteredPokemons ? console.log(filteredPokemons) : "loading ..."} */}
      <div className="main-pokedex">
        <div id="col-1">
          <div className="fixed-filters">
            <SearchInput
              pokemonName={pokemonName}
              onCleanFilter={onCleanFilter}
              handleOnChangeSearch={handleOnChangeSearch}
            />
            <FilterByElements
              resetSearch={setPokemonName}
              pokemonName={pokemonName}
              onCleanFilter={onCleanFilter}
              setFiltroElement={setFiltroElement}
            />
          </div>

          <div className="pokedex-cont">
            {isLoading ? (
              <p>
                (｡•́‿•̀｡)💭⌛️ “Wait a little, a little bit more... ¡It's almost
                done!” ⏳💕
              </p>
            ) : (
              visiblePokemons?.map((pokemon, index) => {
                return (
                  <PokemonCard
                    typeEl={typeEl}
                    setIdMain={setIdMain}
                    setMainDetailsURL={setMainDetailsURL} //envía datos de cada pokemon que serán vistos, stats, evoluciones...
                    mostrar={toggleColumn}
                    key={pokemon?.id || index}
                    pokeURL={pokemon?.url} /* each pokemon url */
                    pokename={pokemon?.name}
                  />
                );
              })
            )}
            {!isLoading && visibleLoading < allPokemons.length && (
              <div ref={loadMoreRef} className="loading-more-container">
                loading more pokemon...
              </div>
            )}
          </div>
        </div>
        {/*
         */}
        <div id={mainDetailsURL.length <= 0 ? `col-2-false` : `col-2-true`}>
          {isDesktop ? (
            Object.keys(mainDetailsURL || {}).length > 0 ? (
              <PokemonDetailsCard
                cleanMainURL={cleanMainURL}
                idMain={idMain}
                mainDetailsURL={mainDetailsURL}
                pokeURL={filteredPokemons?.url}
              />
            ) : (
              <div className="mainPokemon-card">
                <div className=" saturation ">
                  <img
                    className="main-shadow-pikachu"
                    src={
                      "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/home/25.png"
                    }
                    alt="pokemon selected"
                  />
                </div>
                <div id="flex-container-des">
                  <p id="numberID"># Who is that pokémon?</p>
                  <h2>could it be...</h2>

                  <p>{mainDetailsURL?.name}</p>
                </div>
                <div className="main-elements">
                  <div id="abilities-container">
                    <h3>ABILITIES</h3>
                    <div className="abilities">
                      {/* Verifica si types existe antes de mapear */}
                      {mainDetailsURL?.types?.length > 0 ? (
                        mainDetailsURL.types.map((type, index) => (
                          <ButtonRectangle
                            newColorButton={" #af7ac5 "}
                            key={index}
                            complementaryText={type.type.name}
                          />
                        ))
                      ) : (
                        <p>
                          Curious about its abilities? Click the button to find
                          out!🌀
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    maxWidth: "100%",
                    padding: "1rem",
                    textAlign: "center",
                  }}
                >
                  <p
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      margin: ".5rem .2rem",
                    }}
                  >
                    POKEDEX ENTRY
                  </p>
                  <div
                    style={{
                      letterSpacing: "0.2px",
                      hyphens: "auto",
                      margin: ".7rem .2rem",
                    }}
                  >
                    <p>
                      "Something awesome about this Pokémon!💗 Click the details
                      button to learn more!"
                    </p>
                  </div>
                </div>
                <DetailsMesures />
                <Ranking baseExperience={mainDetailsURL?.base_experience} />
                <div id="stats">
                  <h4 style={{ margin: "0 0 1rem" }}>Stats</h4>
                  <div className="rendered-stats">
                    {mainDetailsURL?.stats ? (
                      mainDetailsURL?.stats?.map((stat, index) => {
                        return (
                          <Stats
                            key={index}
                            name={stat.stat.name}
                            base={stat.base_stat}
                          />
                        );
                      })
                    ) : (
                      <div className="lockStats">
                        <p>
                          "Discover how powerful this Pokémon is! Hit the{" "}
                          <span
                            style={{ fontWeight: "300", fontStyle: "italic" }}
                          >
                            "Details ⚡︎ "
                          </span>{" "}
                          button!" 🔍
                        </p>
                      </div>
                    )}
                    {mainDetailsURL?.stats ? (
                      <Stats
                        colorOutcome={colorOutcome}
                        name={"rs"}
                        base={589}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div id="evolutions">
                  <h3 style={{ margin: "0" }}>Evolutions:</h3>

                  <div className="rendered-evolutions">
                    <div className="poke-animated-container">
                      <img
                        alt={"animated"}
                        title={"guess-who"}
                        src={firstEvol}
                        className="single-pok-evolution saturation "
                      />
                    </div>

                    <div className="poke-animated-container ">
                      <img
                        alt={"animated"}
                        title={"guess-who"}
                        src={secondEvol}
                        className="single-pok-evolution saturation "
                      />
                    </div>

                    <div className="poke-animated-container">
                      <img
                        alt={"animated"}
                        title={"guess-who"}
                        src={thirdEvolution}
                        className="single-pok-evolution saturation "
                      />
                    </div>
                  </div>
                </div>
              </div>
              /*elimina esto ros */
            )
          ) : (
            <FichaTecnicaTableta
              idMain={idMain}
              mainDetailsURL={mainDetailsURL}
              pokeURL={filteredPokemons?.url}
            />
          )}

          {isMobile ? (
            Object.keys(mainDetailsURL || {}).length > 0 ? (
              <PokemonDetailsCard
                cleanMainURL={cleanMainURL}
                idMain={idMain}
                mainDetailsURL={mainDetailsURL}
                pokeURL={filteredPokemons?.url}
              />
            ) : (
              ""
            )
          ) : (
            <FichaTecnicaTableta
              idMain={idMain}
              mainDetailsURL={mainDetailsURL}
              pokeURL={filteredPokemons?.url}
            />
          )}
        </div>
      </div>
      <SimpleFooter />
    </div>
  );
}

export default Pokedex;
